import React, { memo, useMemo } from "react";
import classNames from "classnames";
import { useIntl } from "umi";

interface IThinkModeTextCmpProps<S = string> {
  value?: S;
  streamingState?: S;
  className?: string;
}

// think_mode 文本映射配置
const THINK_MODE_TEXT_MAP: Record<string, { zh: string; en: string; }> = {
  fastqa: {
    zh: '已自动路由至快速思考',
    en: 'Automatically routed to Fast Thinking mode',
  },
  deepthink: {
    zh: '已自动路由至深度思考',
    en: 'Automatically routed to Deep Thinking mode',
  },
};

// think_mode 模式文本展示组件
export const ThinkModeTextCmp = memo((props: IThinkModeTextCmpProps) => {
  const { value, className } = props;
  const { locale } = useIntl();

  // 根据 value 值映射固定文本
  const displayText = useMemo(() => {
    if (!value) return '';
    
    const textMap = THINK_MODE_TEXT_MAP[value];
    if (!textMap) return value;
    
    // 默认中文，英文环境使用英文
    return locale === 'en-US' ? textMap.en : textMap.zh;
  }, [value, locale]);

  return (
    <div className={classNames('dba-think-content-left dba-think-mode-text', className)}>
      {displayText}
    </div>
  );
});